import React, { Component } from 'react'
import { Modal } from 'hljd'
import style from './style.module.less'
import { observer, inject } from 'mobx-react'
import { Flex } from 'hljd'
import { Button } from 'hljd'

@inject('detailStore')
@observer
class CollaborateModal extends Component {
  componentDidMount() {
    this.props.detailStore.collaborateModalStore.getSupportList()
  }

  render() {
    const { collaborateModalStore: store } = this.props.detailStore
    const {
      visible,
      add,
      remove,
      selected,
      setStoreData,
      addSupport,
      supportList
    } = store

    return (
      <Modal
        title="协作"
        visible={visible}
        onOk={addSupport}
        onCancel={() => setStoreData({ visible: false })}
        destroyOnClose={true}
        width={400}
      >
        <div>
          <Flex style={{ marginBottom: 25, minHeight: 28 }}>
            <span style={{ width: 70, flexShrink: 0, marginTop: 3 }}>
              负责人：
            </span>

            <Flex vc wrap>
              {selected.map(item => {
                const { id, nick } = item
                return (
                  <div key={id} className={style.selectedItem}>
                    <span className={style.name}>{nick}</span>

                    <img
                      src="//qnm.hunliji.com/o_1d8nojn11lqf1gk2104bn25r4l12.png"
                      className={style.close}
                      onClick={() => remove(item)}
                    />
                  </div>
                )
              })}
            </Flex>
          </Flex>

          <div className={style.row}>添加人员</div>

          {supportList.map(people => {
            const { id, nick, is_admin } = people
            const isSelected = selected.find(item => item.id === id)
            return (
              <Flex key={id} className={style.row} vc sp>
                <Flex vc className={style.label}>
                  <div className={style.admin}>
                    {is_admin == 1 ? '管理员' : '客服'}
                  </div>
                  <div className={style.nick}>{nick}</div>
                </Flex>

                <div className={style.value}>
                  {isSelected ? (
                    <span>
                      <img
                        src="//qnm.hunliji.com/o_1d82k5p8k1e5g18dj10c11l1kkjc12.png"
                        style={{ width: 18, height: 18, marginRight: 5 }}
                      />
                      <span>已添加</span>
                    </span>
                  ) : (
                    <Button type="primary" onClick={() => add(people)}>
                      添加
                    </Button>
                  )}
                </div>
              </Flex>
            )
          })}
        </div>
      </Modal>
    )
  }
}

export default CollaborateModal
